import React from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import { Button, Modal, Alert, InputGroup, InputGroupAddon, Input, Form, FormGroup } from 'reactstrap';
import { hasError, convertToRupiah, getCloudImageUrl } from '../../../utils';
import { RESOURCE_URL } from '../../../config';
import { FormFeedback } from '../../Forms';
const bcaIcon = `${RESOURCE_URL}icons/bca.png`;
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import { IconContext } from 'react-icons';
import { BsArrowLeftShort } from 'react-icons/bs';

const isDisabled = (value, max) => {
  return value == 0 || parseInt(value) > parseInt(max)
}

const BankSection = ({ accountNumber, bankName }) => (
  <div className="text-desc2">
    <p>Confirm cash out and transfer to {accountNumber} Bank {bankName}?</p>
  </div>
)

const ModalCashOutConfirmation = props => {
  const bankAccount = props.dataBank ? props.dataBank.account_name + ' / ' + props.dataBank.bank_name + ' / ' + props.dataBank.account_number : null;
  const receiveAmount = props.amountFee && props.amountFee > 0 ? parseInt(props.value) - parseInt(props.amountFee) : parseInt(props.value);
  return (
    <Modal
      modalClassName="modal-cashout-v3"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <Form
        onSubmit={e => {
          e.preventDefault();
          if (!isDisabled(props.value, props.balance)) props.onNextPage(2);
        }}
      >
        <div className="cashout-content">
          <div className="confirmation-title">
            <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
              <Button className="arrow-prev" onClick={() => props.onNextPage(1)}>
                <BsArrowLeftShort />
              </Button>
            </IconContext.Provider>
            <span>Cash Out Confirmation</span>
          </div>
          <div className="cashout-header">
            <div className="cashout-info">
              <div className="balance-icon">
                <KickImage src={getCloudImageUrl(props.icon, 400)} />
              </div>
              <div className="balance-info">
                <span>{props.title}</span>
                <span>IDR {convertToRupiah(parseInt(props.balance))}</span>
              </div>
            </div>
          </div>
          <div className="cashout-header">
            <div className="cashout-info">
              <div className="balance-icon">
                <KickImage src={getCloudImageUrl(bcaIcon, 400)} />
              </div>
              <div className="balance-info">
                <span>Cash Out to</span>
                <span>{bankAccount}</span>
              </div>
            </div>
          </div>
          <div className="cashout-detail">
            <span>Cash Out Detail</span>
          </div>
          <div className="cashout-header">
            <div className="cashout-grid">
              <div className="cashout-column">
                <span>Cash Nominal</span>
                {props.amountFee !== 0 && <span>Cash Out Fee</span>}
              </div>
              <div className="cashout-column">
                <span className="right">IDR {convertToRupiah(parseInt(props.value))}</span>
                {props.amountFee !== 0 && <span className="right" style={{ color: 'red' }}>-IDR {convertToRupiah(parseInt(props.amountFee))}</span>}
              </div>
            </div>
          </div>
          <div className="cashout-amount">
            <div className="cashout-border">
              <span>Amount to be received</span>
              <span>IDR {convertToRupiah(parseInt(receiveAmount))}</span>
            </div>
          </div>
          <div className="cashout-button">
            <Button
              className="cashout-content"
              onClick={() => props.onNextPage(3)}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default ModalCashOutConfirmation;